module.exports = __webpack_public_path__ + "static/img/banner-small-02.19cf565.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner-small-02.jpg
// module id = 1rcT
// module chunks = 1